module.exports = __webpack_public_path__ + "img/credido 1.1b80bbe6.png";